// Configuración centralizada para Azure DevOps
export const DEVOPS_CONFIG = {
  organization: process.env.REACT_APP_DEVOPS_ORGANIZATION || 'tu-organizacion',
  project: process.env.REACT_APP_DEVOPS_PROJECT || 'ConsultoraHub',
  teams: [
    'App Modernization and AI Solutions',
    'EH Low Code', 
    'Data and AI',
    'ReadySecure',
    'Cloud Black Belt',
    'Change Management',
    "EH Modern Work",
    "EH Demand Hub",
    "PMO Team",
    "Quality and Compliance",
    "Secure",
    "Secure Demand Hub"
  ],
  // El PAT se mantiene como variable de entorno por seguridad
  personalAccessToken: process.env.REACT_APP_DEVOPS_PAT || ''
};

// Función para validar si la configuración está completa
export const isDevOpsConfigComplete = (): boolean => {
  return !!(
    DEVOPS_CONFIG.organization && 
    DEVOPS_CONFIG.organization !== 'tu-organizacion' &&
    DEVOPS_CONFIG.project &&
    DEVOPS_CONFIG.teams.length > 0 &&
    DEVOPS_CONFIG.personalAccessToken
  );
};

// Función para obtener mensaje de configuración faltante
export const getConfigMissingMessage = (): string => {
  const missing: string[] = [];
  
  if (!DEVOPS_CONFIG.organization || DEVOPS_CONFIG.organization === 'tu-organizacion') {
    missing.push('REACT_APP_DEVOPS_ORGANIZATION');
  }
  if (!DEVOPS_CONFIG.project) {
    missing.push('REACT_APP_DEVOPS_PROJECT');
  }
  if (!DEVOPS_CONFIG.personalAccessToken) {
    missing.push('REACT_APP_DEVOPS_PAT');
  }
  if (DEVOPS_CONFIG.teams.length === 0) {
    missing.push('teams configuration');
  }

  return `Configuración Azure DevOps faltante: ${missing.join(', ')}`;
};

export default DEVOPS_CONFIG;